import { createAction } from "redux-act";

export const REQCusServiceList = createAction("REQUEST_CUSSERVICE_LIST");
export const RESCusServiceList = createAction("RECEIVE_CUSSERVICE_LIST");
export const FailCusServiceList = createAction("FAILED_CUSSERVICE_LIST");
export const CleanUpCusServiceList= createAction("CLEANUP_CUSSERVICE_LIST");